// extracted by mini-css-extract-plugin
export default {"countUp":"totalUsersCounter_countUp__FxgLp","countUpHide":"totalUsersCounter_countUpHide__6Imzv"};